<template>
    <div>
        <Breadcrumb :style="{ margin: '20px 10px' }">
            <BreadcrumbItem>角色管理</BreadcrumbItem>
            <BreadcrumbItem>编辑角色权限</BreadcrumbItem>
        </Breadcrumb>
        <loading :loading="loading" :error="error"></loading>
        <Form ref="role" :model="role" label-position="right" :label-width="200" v-if="role">
            <FormItem label="角色名字" prop="name">
                <Input v-model="role.name" placeholder="请输入角色名字" disabled></Input>
            </FormItem>
            <FormItem label="权限" prop="ability">
                <div class="permission-tree-container">
                    <div class="permission-header">
                        <Checkbox 
                            :indeterminate="indeterminate"
                            :value="checkAll"
                            @click.prevent.native="handleCheckAll"
                        >
                            全选
                        </Checkbox>
                    </div>
                    <Tree 
                        :data="treeData" 
                        show-checkbox
                        @on-check-change="handleTreeCheck"
                        ref="permissionTree"
                        :render="renderContent"
                        class="permission-tree"
                    ></Tree>
                </div>
            </FormItem>
            <FormItem>
                <Button type="primary" @click="handleSubmit">提交</Button>
                <Button style="margin-left: 8px" @click="$router.push('/pages/roles')">取消</Button>
            </FormItem>
        </Form>
    </div>
</template>
<script>
import loading from '../loading.vue';
export default {
    components: { loading },
    data () {
        return {
            id: -1,
            is11: '0',
            role: {},
            goods_types: [],
            loading: false,
            error: null,
            permissions: [],
            treeData: [], // Tree 组件需要的数据格式
            selectedPermission: [],
            indeterminate: false,
            checkAll: false
        }
    },
    created () {
        this.id = this.$route.params.id;
        this.loadRoleData();
    },
    watch: {
        // 监听选中权限的变化，更新全选状态
        selectedPermission: {
            handler() {
                this.updateCheckAllStatus();
            },
            deep: true
        },
        // 监听权限数据变化，更新树形数据
        permissions: {
            handler(newVal) {
                if (newVal && newVal.length > 0) {
                    this.treeData = this.convertToTreeData(newVal);
                }
            },
            deep: true
        }
    },
    methods: {
        convertToTreeData(permissions) {
            const self = this;
            return permissions.map(permission => {
                const node = {
                    id: permission.id,
                    title: permission.name,
                    expand: true, // 默认展开
                    children: [],
                    checked: self.selectedPermission.includes(permission.id)
                };
                
                // 如果有子权限，递归处理
                if (permission.children && permission.children.length > 0) {
                    node.children = self.convertToTreeData(permission.children);
                }
                
                return node;
            });
        },
        
        // 加载角色数据
        loadRoleData() {
            this.loading = true;
            this.axios.get('roles/' + this.id).then(res => {
                this.role = res.data.role;
                this.selectedPermission = [];
                if (this.role.permissions && this.role.permissions.length > 0) {
                    this.role.permissions.forEach(per => {
                        this.selectedPermission.push(per.id);
                    });
                }
                console.log('角色已有权限:', this.selectedPermission);
                // 加载权限列表
                this.loadPermissions();
            }).catch(error => {
                this.loading = false;
                this.error = error;
                this.$Message.error('加载角色数据失败');
            });
        },
        
        // 加载权限数据
        loadPermissions() {
            this.loading = true;
            this.axios.get('permissions').then(res => {
                if (res.data.permissions && Array.isArray(res.data.permissions)) {
                    this.permissions = res.data.permissions;
                    console.log('权限列表:', this.permissions);
                } else {
                    this.permissions = [];
                }
                this.loading = false;
            }).catch(error => {
                this.loading = false;
                this.error = error;
                this.$Message.error('加载权限数据失败');
            });
        },
        
        // Tree 节点渲染
        renderContent (h, {  data }) {
            return h('span', {
                style: {
                    display: 'inline-block',
                    width: '100%'
                }
            }, [
                h('span', [
                    h('span', {
                        style: {
                            marginLeft: '4px'
                        }
                    }, data.title)
                ])
            ]);
        },
        
        // Tree 选中状态变化
        handleTreeCheck() {
            // 获取所有选中节点
            const getAllCheckedIds = (nodes) => {
                let ids = [];
                nodes.forEach(node => {
                    if (node.checked) {
                        ids.push(node.id);
                    }
                    if (node.children && node.children.length > 0) {
                        ids = ids.concat(getAllCheckedIds(node.children));
                    }
                });
                return ids;
            };
            
            this.selectedPermission = getAllCheckedIds(this.treeData);
        },
        
        // 处理全选
        handleCheckAll() {
            if (this.indeterminate) {
                this.checkAll = false;
            } else {
                this.checkAll = !this.checkAll;
            }
            this.indeterminate = false;
            
            if (this.checkAll) {
                this.selectAllTreeNodes(true);
            } else {
                this.selectAllTreeNodes(false);
            }
        },
        
        // 全选或取消全选 Tree 节点
        selectAllTreeNodes(checked) {
            const updateNodeChecked = (nodes) => {
                nodes.forEach(node => {
                    node.checked = checked;
                    if (node.children && node.children.length > 0) {
                        updateNodeChecked(node.children);
                    }
                });
            };
            
            updateNodeChecked(this.treeData);
            if (checked) {
                this.selectedAllPermissions();
            } else {
                this.selectedPermission = [];
            }
            this.treeData = [...this.treeData];
        },
        selectedAllPermissions() {
            const getAllPermissionIds = (permissions) => {
                let ids = [];
                permissions.forEach(permission => {
                    ids.push(permission.id);
                    if (permission.children && permission.children.length > 0) {
                        ids = ids.concat(getAllPermissionIds(permission.children));
                    }
                });
                return ids;
            };
            
            this.selectedPermission = getAllPermissionIds(this.permissions);
        },
        updateCheckAllStatus() {
            if (this.permissions.length === 0) {
                this.checkAll = false;
                this.indeterminate = false;
                return;
            }
            const getAllPermissionIds = (permissions) => {
                let ids = [];
                permissions.forEach(permission => {
                    ids.push(permission.id);
                    if (permission.children && permission.children.length > 0) {
                        ids = ids.concat(getAllPermissionIds(permission.children));
                    }
                });
                return ids;
            };
            
            const allPermissionIds = getAllPermissionIds(this.permissions);
            const allCount = allPermissionIds.length;
            const selectedCount = this.selectedPermission.length;
            
            this.checkAll = selectedCount === allCount;
            this.indeterminate = selectedCount > 0 && selectedCount < allCount;
        },
        
        handleSubmit () {
            this.loading = true; 
            this.error = null;
            this.axios.patch("roles/" + this.id + "/permission", { id: this.selectedPermission }).then((res) => {
                console.log("修改返回res", res)
                this.loading = false;
                if (res.data.status === 200) {
                    this.$Message.success('修改成功');
                    setTimeout(() => {
                        this.$router.push("/pages/roles");
                    }, 2000);
                } else {
                    for (let key in res.data.errors) {
                        this.$Message.error(res.data.errors[key][0]);
                    }
                }
            }).catch(error => {
                this.loading = false;
                this.$Message.error('提交失败');
                console.error('提交失败:', error);
            });
        }
    },
};
</script>

<style scoped>
.permission-tree-container {
    border: 1px solid #dcdee2;
    border-radius: 4px;
    background: #fff;
    padding: 10px;
}

.permission-header {
    padding: 10px;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 10px;
}

.permission-tree {
    max-height: 400px;
    overflow-y: auto;
    padding: 10px;
}

/* Tree 组件样式自定义 */
.ivu-tree ul {
    padding-left: 20px;
}

.ivu-tree-title {
    padding: 5px 8px;
    border-radius: 3px;
    transition: background-color 0.2s;
}

.ivu-tree-title:hover {
    background-color: #f5f5f5;
}

.ivu-checkbox-wrapper {
    margin-right: 8px;
}

/* 一级节点样式 */
.ivu-tree > ul > li > .ivu-tree-title {
    font-weight: 500;
    color: #17233d;
}

/* 二级节点样式 */
.ivu-tree ul ul .ivu-tree-title {
    color: #515a6e;
    font-weight: normal;
}
</style>